"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Button = _interopRequireDefault(require("@material-ui/core/Button"));
var _clsx = _interopRequireDefault(require("clsx"));
var _styles = _interopRequireDefault(require("./styles"));
var _excluded = ["children", "variant", "onClick"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
var Button = props => {
  var {
      children,
      variant,
      onClick
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  var classes = (0, _styles.default)(props);
  var classesConfig = {
    root: classes.root
  };
  var buttonType = 'outlined';
  if (variant === 'primary') classesConfig.root = (0, _clsx.default)(classes.root, classes.primaryRoot);else if (variant === 'secondary') classesConfig.root = (0, _clsx.default)(classes.root, classes.secondaryRoot);else if (variant === 'contained') classesConfig.root = (0, _clsx.default)(classes.root, classes.containedRoot);else if (variant === 'text') buttonType = 'text';
  return /*#__PURE__*/_react.default.createElement(_Button.default, _extends({
    component: 'button',
    variant: buttonType,
    classes: classesConfig,
    onClick: onClick
  }, rest), children);
};
Button.defaultProps = {
  fullWidth: false
};
var _default = exports.default = Button;